import React from 'react'
import type { ComponentConfig, Slot } from '@puckeditor/core'
import * as styles from './Flex.module.scss'
import { getClassNameFactory } from '../../utils/get-class-name-factory'
import { Section } from '../../components/Section'
import { WithLayout, withLayout } from '../../components/Layout'

const getClassName = getClassNameFactory('Flex', styles)

export type FlexProps = WithLayout<{
  justifyContent: 'start' | 'center' | 'end'
  alignItems: 'start' | 'center' | 'end' | 'stretch' | 'baseline'
  direction: 'row' | 'column'
  gap: number
  wrap: 'wrap' | 'nowrap'
  items: Slot
}>

const FlexInternal: ComponentConfig<FlexProps> = {
  fields: {
    direction: {
      label: 'Direction',
      type: 'radio',
      options: [
        { label: 'Row', value: 'row' },
        { label: 'Column', value: 'column' },
      ],
    },
    justifyContent: {
      label: 'Justify Content',
      type: 'radio',
      options: [
        { label: 'Start', value: 'start' },
        { label: 'Center', value: 'center' },
        { label: 'End', value: 'end' },
      ],
    },
    alignItems: {
      label: 'Align Items',
      type: 'select',
      options: [
        { label: 'Stretch', value: 'stretch' },
        { label: 'Start', value: 'start' },
        { label: 'Center', value: 'center' },
        { label: 'End', value: 'end' },
        { label: 'Baseline', value: 'baseline' },
      ],
    },
    gap: {
      label: 'Gap',
      type: 'number',
      min: 0,
    },
    wrap: {
      label: 'Wrap',
      type: 'radio',
      options: [
        { label: 'Yes', value: 'wrap' },
        { label: 'No', value: 'nowrap' },
      ],
    },
    items: {
      type: 'slot',
      disallow: ['Hero', 'Stats'],
    },
  },
  defaultProps: {
    justifyContent: 'start',
    alignItems: 'stretch',
    direction: 'row',
    gap: 24,
    wrap: 'wrap',
    layout: {
      grow: true,
    },
    items: [],
  },
  render: ({ justifyContent, alignItems, direction, gap, wrap, items: Items }) => {
    return (
      <Section paddingInline="0">
        <Items
          className={`${getClassName()} no-slot-padding`}
          style={{
            justifyContent,
            alignItems,
            flexDirection: direction,
            gap,
            flexWrap: wrap,
          }}
          disallow={['Hero', 'Stats']}
        />
      </Section>
    )
  },
}

export const Flex = withLayout(FlexInternal)
